import GoodocSplashScreen from '@assets/animation/goodoc-loading.json';
import Lottie from 'lottie-web';
import { FC, Fragment, useEffect, useRef } from 'react';

import * as styles from './styles';

interface LoadingProps {
  visible: boolean;
}

const Loading: FC<LoadingProps> = ({ visible }) => {
  const ref = useRef<HTMLDivElement>(null);

  const name = 'LOADING';

  useEffect(() => {
    if (visible && ref.current) {
      Lottie.loadAnimation({
        name,
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: GoodocSplashScreen
      });
    }
    return () => Lottie.destroy(name);
  }, [visible]);

  return (
    <Fragment>
      {visible && (
        <div css={styles.frame}>
          <div css={styles.container}>
            <div ref={ref} css={styles.loadingAnimation} />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Loading;
